import { graphql, useStaticQuery } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import React from "react"

const query = graphql`
  {
    allContentfulGattoboInfo {
      nodes {
        title
        media {
          gatsbyImageData
        }
      }
    }
  }
`

const GattoboInfo = () => {
  const data = useStaticQuery(query)
  const items = data.allContentfulGattoboInfo.nodes.map(item => ({
    title: item.title,
    image: item.media ? getImage(item.media) : null,
  }))
  
  return (

    <div className="mt-12 md:mt-28">
      <div className="text-center text-2xl font-bold">【NEW!!】</div>
      {items.map((item, index) => (
        <div key={index} className="mb-6 md:mb-8 last:mb-0">
          {/* 画像がある場合：GatsbyImageで表示 */}
          {item.image ? (
            <GatsbyImage
              image={item.image}
              alt={item.title || "画像"}
              className="w-full h-auto"
            />
          ) : null }
        </div>
      ))}
        <div className="mb-6 md:mb-8 last:mb-0">
          <iframe className="w-full h-auto aspect-video" src="https://www.youtube.com/embed/GmNnkwqVXMk?si=1giH-EMiSKKoN0m6" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </div>
    </div>
  )
}

export default GattoboInfo